var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkHost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.665 13.571C12.4413 14.9153 12 16.2141 11.3585 17.4165C10.8165 18.3585 10.221 19 9.50003 19C8.77905 19 8.18356 18.3585 7.64157 17.4165C7.00023 16.2141 6.55912 14.9153 6.33559 13.571H12.665ZM4.68512 13.571H0.915183C1.45707 14.7081 2.21869 15.7267 3.15612 16.568C4.09355 17.4093 5.18824 18.0568 6.37709 18.473C6.32709 18.394 6.27709 18.3125 6.22909 18.229C5.45463 16.7749 4.93272 15.1998 4.68562 13.571H4.68512ZM18.0849 13.571H14.3149C14.0677 15.1999 13.5456 16.7749 12.771 18.229C12.723 18.3125 12.673 18.394 12.623 18.473C13.8119 18.0568 14.9067 17.4094 15.8442 16.5681C16.7817 15.7267 17.5434 14.7081 18.0854 13.571H18.0849ZM4.46262 7.056H0.316694C-0.105565 8.65713 -0.105565 10.3404 0.316694 11.9415H4.46262C4.30434 10.317 4.30434 8.68099 4.46262 7.0565V7.056ZM12.9025 7.056C12.9876 7.86787 13.0297 8.68368 13.0285 9.5C13.0293 10.3155 12.9869 11.1305 12.9015 11.9415H6.09809C5.92862 10.3176 5.92862 8.68042 6.09809 7.0565L12.9025 7.056ZM18.6834 7.056H14.5374C14.6177 7.86818 14.6573 8.68387 14.6559 9.5C14.6573 10.3153 14.6177 11.1302 14.5374 11.9415H18.6834C19.1055 10.3405 19.1055 8.65747 18.6834 7.0565V7.056ZM6.37709 0.525C5.18817 0.941648 4.09346 1.58947 3.15604 2.43113C2.21863 3.2728 1.45705 4.29166 0.915183 5.429H4.68612C4.93323 3.80016 5.45514 2.2251 6.22959 0.771C6.27759 0.6875 6.32709 0.606 6.37709 0.525ZM12.6645 5.429H6.33559C6.55914 4.08394 7.00024 2.78426 7.64157 1.581C8.18356 0.6415 8.77905 0 9.50003 0C10.221 0 10.8165 0.6415 11.3585 1.581C11.9998 2.78427 12.4409 4.08394 12.6645 5.429ZM12.623 0.525C12.673 0.606 12.723 0.6875 12.771 0.771C13.5454 2.2251 14.0673 3.80016 14.3144 5.429H18.0854C17.5438 4.29139 16.7822 3.27232 15.8447 2.43062C14.9071 1.58892 13.8122 0.941247 12.623 0.525Z",
    fill: "url(#paint0_linear_208_778)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_208_778",
    x1: 1.92371e-7,
    y1: 19,
    x2: 20.6208,
    y2: 17.0384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD297E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B01FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkHost);
export default __webpack_public_path__ + "static/media/dark-host.80b17d8331e23d07e6a2a0b8d460c3ce.svg";
export { ForwardRef as ReactComponent };